import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Collapse from '../UI/Collapse';

/** Botão "Ver métricas / Ocultar métricas" (mesmo visual de Vendas). */
export default function MetricsToggle({ open, onToggle }) {
    return (
        <button
            type="button"
            onClick={onToggle}
            aria-expanded={open}
            className="inline-flex items-center justify-center gap-2 py-2 px-4 rounded-xl border border-dashed border-white/[0.08] text-white/60 text-sm hover:text-white hover:border-white/20 transition-colors"
        >
            {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            {open ? 'Ocultar métricas' : 'Ver métricas'}
        </button>
    );
}

/**
 * Métricas recolhíveis (telas do admin): botão à direita e os cartões
 * escondidos por padrão — só aparecem quando pedidos.
 */
export function CollapsibleMetrics({ children, className = 'mt-4' }) {
    const [open, setOpen] = useState(false);
    return (
        <div className={className}>
            <div className="flex justify-end">
                <MetricsToggle open={open} onToggle={() => setOpen((v) => !v)} />
            </div>
            <Collapse open={open} innerClassName="pt-4">{children}</Collapse>
        </div>
    );
}
